module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis16-f44f27fece4470189fe6589469d9fbae.jpg";